import { DashboardLayout } from "@/components/dashboard-layout";
import { Card, CardContent } from "@/components/ui/card";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/organisations/$orgId/emails")({
  component: RouteComponent,
  loader: async () => ({
    crumb: "Emails",
  }),
});

function RouteComponent() {
  return (
    <Card>
      <CardContent>
        <p className="text-md pb-20 pt-15 text-center">
          Emails are not yet available in this client. To manage emails, please use the legacy admin client.
        </p>
      </CardContent>
    </Card>
  );
}
